import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import { toast } from 'react-hot-toast';
import { ShoppingCart, Lock, Mail } from 'lucide-react';
import './LoginPDV.css';

const LoginPDV = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Se já estiver logado e for operador_caixa, redirecionar
  useEffect(() => {
    if (user && (user.tipo === 'operador_caixa' || user.tipo === 'admin' || user.tipo === 'estabelecimento')) {
      navigate('/pdv');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('🔐 Tentando login com:', email);
      const response = await login(email, senha);
      
      console.log('📋 Resposta completa do login:', JSON.stringify(response, null, 2));
      
      // Verificar se o login foi bem-sucedido
      if (response && response.success) {
        const user = response.user;
        console.log('👤 Usuário retornado:', user);
        
        // Verificar se o usuário é operador_caixa ou admin/estabelecimento
        if (user && (user.tipo === 'operador_caixa' || user.tipo === 'admin' || user.tipo === 'estabelecimento')) {
          toast.success('Login realizado com sucesso!');
          // Aguardar um pouco para garantir que o estado foi atualizado
          setTimeout(() => {
            console.log('🔄 Redirecionando para /pdv');
            // Usar window.location.href para forçar reload completo
            window.location.href = '/pdv';
          }, 300);
        } else {
          // Usuário não é operador de caixa - limpar token
          localStorage.removeItem('token');
          delete api.defaults.headers.common['Authorization'];
          toast.error('Acesso negado. Este login é apenas para operadores de caixa.');
          setLoading(false);
        }
      } else {
        const errorMsg = response?.error || response?.message || 'Credenciais inválidas';
        console.error('❌ Erro no login:', errorMsg);
        toast.error(errorMsg);
        setLoading(false);
      }
    } catch (error) {
      console.error('❌ Erro no login (catch):', error);
      console.error('   Response:', error.response);
      const errorMsg = error.response?.data?.message || error.message || 'Erro ao fazer login';
      toast.error(errorMsg);
      setLoading(false);
    }
  };

  return (
    <div className="login-pdv-container">
      <div className="login-pdv-card">
        <div className="login-pdv-header">
          <div className="logo-pdv">
            <ShoppingCart size={48} />
          </div>
          <h1>PDV - Frente de Caixa</h1>
          <p>Cantinho do Sabor</p>
        </div>

        <form onSubmit={handleSubmit} className="login-pdv-form">
          <div className="input-group-pdv">
            <Mail size={20} />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="input-group-pdv">
            <Lock size={20} />
            <input
              type="password"
              placeholder="Senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-pdv-primary" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar no PDV'}
          </button>
        </form>

        <div className="login-pdv-footer">
          <p>Acesso restrito para operadores de caixa</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPDV;

